module.exports = __webpack_public_path__ + "static/media/other.45103db0.svg";